import React from "react";
import { useTranslation } from "react-i18next";

import { useInterviewStore } from "../../../store/useInterviewStore";
import {postReviewData} from "../../../api/reviewApi";
import {useNotification} from "../../Notifications/NotificationsContext";

export const ReviewNotificationRow = ({
  data,
  handleDeleteElement,
  navigate,
  slugData,
  month,
}) => {
  const { t } = useTranslation();

  const { setView } = useInterviewStore();
    const { updateNotificationCount } = useNotification();

  const fetchReviewData = async (id) => {
        try {
            const result = await postReviewData(id);
            updateNotificationCount();
            navigate("/search-providers/Reviews");
        } catch (error) {
            console.error("Error fetching review data:", error);
        }
    };

  return (
    <tr className={data.read_status === 0 ? "unread" : ""}>
      <td className="view-message dont-show">
        <input
          type="checkbox"
          className="mail-radio"
          name="chk"
          onChange={() => handleDeleteElement(data.id)}
        />
        <span className="circle"></span>
        <span
          onClick={() => {
            fetchReviewData(data.id);
          }}
        >
          {data.read_status === 0 ? (
            <span className="new-tag"> {t("text-new-up")}</span>
          ) : (
            ""
          )}
          <span
            className="username-text"
            onClick={() => {
                data.read_status = 1;
              navigate("/search-providers/Reviews");
            }}
          >
            {data.SenderName}
          </span>
          - {data.review_title}
        </span>
      </td>
      <td className="view-message text-right">
        {month[new Date(data.created_at).getMonth()] +
          " " +
          new Date(data.created_at).getDate()}
      </td>
    </tr>
  );
};
